import * as Collapsible from '@radix-ui/react-collapsible';
import { CaretRightIcon } from '@radix-ui/react-icons';
import type { ReactNode } from 'react';

interface ToolpadProps {
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  children: ReactNode;
}

export function Toolpad({ title, isOpen, onToggle, children }: ToolpadProps) {
  return (
    <Collapsible.Root open={isOpen} onOpenChange={onToggle} className="toolpad">
      <Collapsible.Trigger asChild>
        <div className="toolpad-header">
          <span className="toolpad-title">{title}</span>
          <span className={`toolpad-toggle ${isOpen ? 'open' : ''}`}><CaretRightIcon className={`${isOpen ? 'open' : 'closed'}`} width={16} height={16} /></span>
        </div>
      </Collapsible.Trigger>
      <Collapsible.Content className="toolpad-content">
        {children}
      </Collapsible.Content>
    </Collapsible.Root>
  );
}
